import { Group, User } from "app/types"

interface CanAccessPostsOptions {
  user?: Pick<User, 'userType'> | null
  group?: Pick<Group, 'visibility' | 'allowedUserTypes'>
  isMember?: boolean
}

export const canAccessPosts = (options: CanAccessPostsOptions) => {
  const { user, group, isMember } = options

  if (!user || !group) {
    return false
  }

  if (!group.allowedUserTypes.includes(user?.userType || '')) {
    return false
  }

  if (group?.visibility === 'private' && !isMember) {
    return false
  }

  return true
}
